module.exports = __webpack_public_path__ + "img/corner-up-right.13c8f859.svg";